export default "__VITE_ASSET__BySGSVuw__"